import Container from "../atoms/Container"

// Dentro la scheda aperta i blocchi (presenze, programma, note, chi l'ha
// segnata) stanno a 16px dai bordi, dove cominciano le scritte della scheda
// e finiscono i bottoni sotto (#214). Col Container di tutta l'app stavano a
// 8, e il riquadro del programma sporgeva oltre il nome dell'allievo.
function CardInset(props) {
	return <Container maxW="calc(100% - 2rem)" {...props} />
}

export default CardInset
